import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { preloadPublicRoutes } from './core/routes';
import reportWebVitals from './reportWebVitals';
import { loadTranslationsBundle } from './i18n/translationsLoader';

loadTranslationsBundle(); // Fire-and-forget, blockiert das Rendern nicht

// Nach einem Deployment sind alte JS-/CSS-Dateien weg: Wer die Seite noch offen hat, bekommt beim Weiterklicken
// "Loading chunk … failed" und eine weiße Seite. Dann einmal automatisch neu laden (Schutz gegen Endlosschleife).
const reloadOnChunkError = (text) => {
    if (!/Loading (CSS )?chunk|ChunkLoadError/i.test(text)) return;
    try {
        if (sessionStorage.getItem('chunk_reload')) return;
        sessionStorage.setItem('chunk_reload', '1');
    } catch { /* Storage nicht verfügbar: trotzdem einmal neu laden */ }
    window.location.reload();
};
window.addEventListener('error', (e) => reloadOnChunkError(String((e && e.message) || '')));
window.addEventListener('unhandledrejection', (e) => reloadOnChunkError(String(e && e.reason ? `${e.reason.name} ${e.reason.message}` : '')));
setTimeout(() => { try { sessionStorage.removeItem('chunk_reload'); } catch { /* ignorieren */ } }, 15000);

const rootElement = document.getElementById('root');

// Hydration-Mismatches (z.B. durch minimale Zeit-/Storage-Drift zwischen
// react-snap-Snapshot und tatsächlichem Aufruf) sollen NICHT als Uncaught
// Error in der Konsole landen. React fällt bei einem Mismatch ohnehin
// automatisch auf einen vollständigen Client-Render zurück -
// onRecoverableError sorgt nur dafür, dass das sauber geloggt statt als
// Crash (React Error #418) angezeigt wird.
const onRecoverableError = (error, errorInfo) => {
    if (process.env.NODE_ENV !== 'production') {
        console.warn('Hydration recovered:', error, errorInfo?.componentStack);
    }
};

const start = () => {
  // Vom Server mitgelieferter Seiteninhalt für Suchmaschinen (unsichtbar) – die App rendert die Seite jetzt selbst
  document.getElementById('seo-ssr')?.remove();
  document.querySelectorAll('[data-ssr]').forEach((el) => el.remove());
  // Falls react-snap bereits HTML vorgerendert hat (Kinder-Elemente vorhanden),
  // wird hydriert statt neu gerendert – behält den vorgerenderten Content
  // bis React übernimmt, statt ihn erst zu löschen und neu aufzubauen.
  if (rootElement.hasChildNodes()) {
      ReactDOM.hydrateRoot(rootElement, <App />, { onRecoverableError });
  } else {
      const root = ReactDOM.createRoot(rootElement);
      root.render(<App />);
  }
};
// Instanz-Modul der öffentlichen Seite zuerst laden, dann hydrieren (siehe core/routes.js)
preloadPublicRoutes().then(start, start);
reportWebVitals();